import React, {Component} from 'react';
import Radium from 'radium';
import portrait from '../assets/portrait.jpg';
import {Device} from './shared.js';

class Portrait extends Component {
  render() {
    let dimesion = 320;
    if (Device.isTablet()) {
      dimesion = 260;
    }
    if (Device.isMobile()) {
      dimesion = 155;
    }

    const style = {
      backgroundImage: `url(${ portrait })`,
      backgroundPosition: '45% top',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '160%',
      borderRadius: '100%',
      height: dimesion,
      position: 'absolute',
      right: (Device.isDesktopSmall() || Device.isDesktopLarge()) ? 50 : -dimesion / 20,
      top: `calc(100% - ${ dimesion / 2 }px)`,
      width: dimesion,
    }

    return (
      <div 
        id="portrait"
        style={ style }>
      </div>
    );
  }
}

export default Radium(Portrait);


// WEBPACK FOOTER //
// ./src/modules/portrait.js